<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { Primitive, type PrimitiveProps } from 'radix-vue'
import { type ButtonVariants, buttonVariants } from '.'
import { cn } from '@/utils'

interface Props extends PrimitiveProps {
  variant?: ButtonVariants['variant']
  size?: ButtonVariants['size']
  class?: HTMLAttributes['class']
  /** This prop will be forwarded to the underlying button element */
  type?: string
}

const props = withDefaults(defineProps<Props>(), {
  as: 'button',
  type: 'button', // default to "button"; can be set to "submit" when needed.
})
</script>

<template>
  <Primitive
    :type="props.type"
    :as="props.as"
    :as-child="props.asChild"
    :class="cn(buttonVariants({ variant: props.variant, size: props.size }), props.class)"
  >
    <slot />
  </Primitive>
</template>
